export default __webpack_public_path__ + "static/media/Path.a310b6b0.svg";